import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './main.scss'
import Common from './plugins/common'
import Datadog from './plugins/datadog'
import VueTheMask from 'vue-the-mask'
import { datadogRum } from '@datadog/browser-rum'

Vue.use(VueTheMask)
Vue.use(Common, store.dispatch)
Vue.use(Datadog, datadogRum)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
